// extracted by mini-css-extract-plugin
export default {"img":"lang_img__5FX0T"};